// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';

// Suppress ResizeObserver errors - More aggressive approach
const originalError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  if (message.includes('ResizeObserver') || 
      message.includes('ResizeObserver loop') ||
      message.includes('ResizeObserver loop completed')) {
    return;
  }
  originalError(...args);
};

// Suppress at window level
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver') || 
      e.message?.includes('ResizeObserver loop')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

// Override the global error handler
if (typeof window !== 'undefined') {
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message?.toString().includes('ResizeObserver')) {
      return true;
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);